import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { ApiService } from '../services/api.service';
import { ModalService } from '../vqutils/vq-modal/vq-modal.component';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styles: []
})
export class AdminsComponent implements OnInit {

  admins = [];
  users = [];
  admin: string = null;
  errors: any = [];
  spaceId;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _as: AlertService,
    private _api: ApiService,
    private _ms: ModalService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if (params['id']) {
          this.spaceId = params['id'];
          this._api.users
            .list()
            .subscribe(
              (data) => {
                this.users = data.results;
                this._api.admins
                  .list({ space: this.spaceId })
                  .subscribe(
                    (data) => {
                      this.admins = data.results;
                    },
                    (errors) => {
                    })
              },
              (errors) => {
              })
        }
      })
  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }

  getUserLabel(obj) {
    return obj.last_name + ' ' + obj.first_name + ' (' + obj.email + ')';
  }

  getUserFromId(uid) {
    let foundUser = this.users.find((o) => o.id === uid);
    if (foundUser) {
      return this.getUserLabel(foundUser)
    } else {
      return 'Utilisateur desactivé'
    }
  }

  addRow() {
    if (!this.admin) {
      this._as.danger('Vous devez sélectionner un utilisateur');
      return;
    }
    let existingAdmins = this.admins.map((o) => o.user);
    console.log(existingAdmins);
    console.log(this.admin);
    if (existingAdmins.indexOf(parseInt(this.admin)) > -1) {
      this._as.danger('Cet utilisateur est déjà administrateur de ce chantier');
      return;
    }
    this.isLoading = true;
    this._api.admins
      .create({ user: this.admin, space: this.spaceId })
      .subscribe(
        (data) => {
          this._as.success('L\'utilisateur a été ajoutée');
          this.admins.push({ ...data });
          this.admin = null;
          this.isLoading = false;
        },
        (errors) => {
          this.errors = errors;
          this._as.danger('Des erreurs empêchent l\'ajout de l\'administrateur');
          this.isLoading = false;
        })
  }

  private _deleteRow(row) {
    this._api.admins
      .destroy(row.id)
      .subscribe(
        (data) => {
          this._as.success('L\'administrateur a été supprimé');
          this.admins = this.admins.filter(o => o != row);
        },
        (errors) => {
          this._as.danger('Des erreurs empêchent la suppression de l\'administrateur');
        })
  }

  deleteRow(row) {
    this._ms.delete({
      confirm: () => this._deleteRow(row)
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/admins/admins.component.ts